<template>
    <div>
        <form @submit.prevent="saveDeliveryDate" @keydown="formDeliveryDateSelection.onKeydown($event)">
            <div class="row">
                <div class="col">
                    <calendar
                        class="rounded-0"
                        :locale="locale == 'tw' ? 'zh-TW' : 'en'"
                        mode="date"
                        v-model="formDeliveryDateSelection.delivery_date"
                        :model-config="dateModelConfig"
                        :columns="$screens({ default: 1, lg: 2 })"
                        :rows="$screens({ default: 1 })"
                        :min-date="minDateDelivery"
                        :max-date="maxDateDelivery"
                        :disabled-dates='disabledDates'
                        :timezone="app_timezone"
                        is-expanded
                        :select-attribute="{
                            highlight: {
                                style: { background: '#000' },
                                contentStyle: { color: '#fff' },
                            },
                        }"
                    />
                </div>
                <div v-if="config.modules.delivery_time_selection" class="col-2 small">
                    <div>{{ t.checkout.delivery_time }}</div>
                    <div v-for="timeSlot in timeSlots" :key="timeSlot" @click="formDeliveryDateSelection.delivery_time = timeSlot"
                    class="border border-dark py-1 text-center mb-3 cursor-pointer"
                    :class="{'bg-dark text-white': formDeliveryDateSelection.delivery_time == timeSlot}">
                        {{ timeSlot }}
                    </div>
                </div>
            </div>
            <div class="small text-danger" v-if="formDeliveryDateSelection.errors.has('delivery_date')" v-html="formDeliveryDateSelection.errors.get('delivery_date')"></div>
            <div class="small text-danger" v-if="formDeliveryDateSelection.errors.has('delivery_time')" v-html="formDeliveryDateSelection.errors.get('delivery_time')"></div>
            <div class="mt-3">
                <button class="btn btn-secondary" type="button" :disabled="formDeliveryDateSelection.busy" @click="$listeners.back()">{{ t.global.back}}</button>
                <button class="btn btn-primary" type="submit" :disabled="formDeliveryDateSelection.busy">{{ t.checkout.next_step}}</button>
            </div>
        </form>
    </div>
</template>
<script>
import Calendar from "v-calendar/lib/components/date-picker.umd"
import Form from 'vform'
export default {
    store: store,
    components: {
        Calendar,
    },
    data() {
        return {
            t: t,
            config: config,
            locale: locale,
            app_timezone: app_timezone,
            minDateDelivery: minDateDelivery,
            maxDateDelivery: maxDateDelivery,
            disabledDates: disabledDates,
            timeSlots: timeSlots,
            dateModelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            formDeliveryDateSelection: new Form({
                delivery_date: delivery_date ? delivery_date : null,
                delivery_time: delivery_time ? delivery_time : null,
            }),
        }
    },
    methods: {
        async saveDeliveryDate () {
            const response = await this.formDeliveryDateSelection.post(this.url('ajax/checkout/delivery-date-selection'))
            if (response.data.success) {
                this.$listeners.goToNextStep()
                if (response.data.message) {
                    this.$notify({text: response.data.message, type: 'success'})
                }
                EventBus.$emit('cart-changed')
            }
        },
    },
    computed: {
    },
    mounted() {
    }
}
</script>
